import { IRootState } from '../../../store'
import { IFactorsAffectingCareState } from '../store/factorsAffectingCare.types'

export const getFactorsAffectingCareSelector = (state: IRootState): IFactorsAffectingCareState =>
  state.factorsAffectingCareState
